import { defineStore } from 'pinia';
import { ref } from 'vue';

export type ClientAcceptingDialogCallback = (status: string) => void;
interface ConfirmProps {
  cancelButtonText?: string | null;
  confirmButtonText?: string;
  hideCloseIcon?: boolean;
  maxWidth?: string;
  buttonFullWidth?: boolean;
  zIndex?: number;
  size?: 's' | 'm' | 'l';
}

export interface ClientAcceptingDialogOptions extends ConfirmProps {
  callback?: ClientAcceptingDialogCallback;
}

export interface ClientAcceptingDialogData extends ClientAcceptingDialogOptions {
  resolve: (value: boolean) => void;
}

export const useClientAcceptingDialogStore = defineStore('clientAcceptingDialog', () => {
  const isOpen = ref<boolean>(false);
  const props = ref<ClientAcceptingDialogData | null>(null);

  const openClientAcceptingDialog = (dialogData: ClientAcceptingDialogData): void => {
    props.value = dialogData;
    isOpen.value = true;
  };

  const onClose = (confirmed: boolean): void => {
    if (props.value) {
      props.value.resolve(confirmed);
      // Adjust the interval for the animation
      setTimeout(() => {
        isOpen.value = false;
        props.value = null;
      }, 0);
    }
    isOpen.value = false;
  };

  return { isOpen, props, openClientAcceptingDialog, onClose };
});

export const openClientAcceptingDialog = (
  options?: ClientAcceptingDialogOptions,
): Promise<boolean> => {
  return new Promise((resolve) => {
    useClientAcceptingDialogStore().openClientAcceptingDialog({ ...options, resolve });
  });
};
